module.exports = __webpack_public_path__ + "img/TrollingTraff-blackandblue-e1456176509215.0971ebdf.jpg";